var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1001F"
    },
    d: "M304.205,0h-96.403c-8.284,0-15,6.716-15,15c0,18.307-14.895,33.201-33.201,33.201 c-8.867,0-17.204-3.453-23.475-9.725c-6.271-6.271-9.724-14.608-9.723-23.475c0-3.979-1.58-7.795-4.393-10.608 C119.197,1.58,115.382,0,111.403,0H15C6.716,0,0,6.716,0,15v192.797c0,8.285,6.716,15,15,15h289.205c8.284,0,15-6.715,15-15V15 C319.205,6.716,312.489,0,304.205,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#980017"
    },
    d: "M304.205,0h-96.403c-8.284,0-15,6.716-15,15c0,18.307-14.894,33.2-33.199,33.201v174.596h144.603 c8.284,0,15-6.715,15-15V15C319.205,6.716,312.489,0,304.205,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1001F"
    },
    d: "M497,319.199c8.284,0,15-6.717,15-15v-96.402c0-8.284-6.716-15-15-15H15c-8.284,0-15,6.716-15,15 v96.402c0,8.283,6.716,15,15,15c18.307,0,33.2,14.893,33.2,33.199c0,18.307-14.894,33.201-33.2,33.201c-8.284,0-15,6.715-15,15V497 c0,8.285,6.716,15,15,15h482c8.284,0,15-6.715,15-15v-96.4c0-8.285-6.716-15-15-15c-18.307,0-33.2-14.895-33.2-33.201 C463.8,334.092,478.693,319.199,497,319.199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#980017"
    },
    d: "M497,319.199c8.284,0,15-6.717,15-15v-96.402c0-8.284-6.716-15-15-15H256V512h241 c8.284,0,15-6.715,15-15v-96.4c0-8.285-6.716-15-15-15c-18.307,0-33.2-14.895-33.2-33.201 C463.8,334.092,478.693,319.199,497,319.199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCBF29"
    },
    d: "M352.4,192.797H159.6c-8.284,0-15,6.716-15,15V497c0,8.285,6.716,15,15,15h192.8 c8.284,0,15-6.715,15-15V207.797C367.4,199.513,360.685,192.797,352.4,192.797z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE9923"
    },
    d: "M352.4,192.797H256V512h96.4c8.284,0,15-6.715,15-15V207.797 C367.4,199.513,360.685,192.797,352.4,192.797z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponPerformance);
export default __webpack_public_path__ + "static/media/couponPerformance.484f9508b4287085e2bc100fa75e6bd4.svg";
export { ForwardRef as ReactComponent };